import MachineReportDetailsDataSlice from './machineReportDetailsDataSlice';
import ArticleFolderDetailsDataSlice from './articleFolderDetailsDataSlice';
import SucccessfullModifyDialogSlice from './successfullModifyDialogSlice';
import MachineNoteDetailsDataSlice from './machineNoteDetailsDataSlice';
import EquipmentDetailsDataSlice from './equipmentDetailsDataSlice';
import ContractDetailsDataSlice from './contractDetailsDataSlice';
import InvoiceDetailsDataSlice from './invoiceDetailsDataSlice';
import MachineDetailsDataSlice from './machineDetailsDataSlice';
import CompanyDetailsDataSlice from './companyDetailsDataSlice';
import RegionDetailsDataSlice from './regionDetailsDataSlice';
import MetierDetailsDataSlice from './metierDetailsDataSlice';
import MarqueDetailsDataSlice from './marqueDetailsDataSlice';
import RisqueDetailsDataSlice from './risqueDetailsDataSlice';
import SiteDetailsDataSlice from './siteDetailsDataSlice';
import UserDetailsDataSlice from './userDetailsDataSlice';
import PoleDetailsDataSlice from './poleDetailsDataSlice';
import roleDetailsDataSlice from './roleDetailsDataSlice';
import machineNoteListSlice from './machineNoteListSlice';
import onlineStatusReducer from './onlineStatusSlice';
import { configureStore } from '@reduxjs/toolkit';
import userSlice from './userSlice';

const store = configureStore({
  reducer: {
    AuthenticatedUser: userSlice,
    MachineDetailsData: MachineDetailsDataSlice,
    MachineNoteDetailsData: MachineNoteDetailsDataSlice,
    MachineReportDetailsData: MachineReportDetailsDataSlice,
    UserDetailsData: UserDetailsDataSlice,
    RoleDetailsData: roleDetailsDataSlice,
    onlineStatus: onlineStatusReducer,
    ContractDetailsData: ContractDetailsDataSlice,
    InvoiceDetailsData: InvoiceDetailsDataSlice,
    SuccessfullModifyDialog: SucccessfullModifyDialogSlice,
    CompanyDetailsData: CompanyDetailsDataSlice,
    SiteDetailsData: SiteDetailsDataSlice,
    PoleDetailsData: PoleDetailsDataSlice,
    RegionDetailsData: RegionDetailsDataSlice,
    MetierDetailsData: MetierDetailsDataSlice,
    MarqueDetailsData: MarqueDetailsDataSlice,
    RisqueDetailsData: RisqueDetailsDataSlice,
    machineNoteList: machineNoteListSlice,
    EquipmentDetailsData: EquipmentDetailsDataSlice,
    ArticleFolderDetailsData: ArticleFolderDetailsDataSlice,
  },
});

export default store;